const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

export async function getHeros() {
  const res = await fetch(`${apiUrl}/api/hero_list`);
  return res.json();
}